<div class="container wwd">
  <h2 class="sr-page-h1 sr-bold black-text lighten-1">{{ 'WHAT-WE-DO' | translate }}</h2>

  <div class="wwd-tabs">
    <a
      class="wwd-tab"
      *ngFor="let tab of tabs"
      [routerLink]="['/what-we-do', tab.route]"
      routerLinkActive="wwd-tab--active"
    >
      <img class="wwd-tab__icon" [src]="tab.icon" alt="" aria-hidden="true" />
      <span class="wwd-tab__label" [innerHTML]="tab.labelKey | translate"></span>
    </a>
  </div>

  <div class="wwd-panel">
    <router-outlet></router-outlet>
  </div>
</div>
